<!-- <div class="backdrop"></div> -->
<div class="toast-box">
  <img src="../../../assets/images/success_onToast.svg" alt="success" />
  <p>
    {{ message }}
  </p>
</div>
